module.exports = __webpack_public_path__ + "static/media/keepLeft.57dbf4ab.svg";